import { createAction, props } from '@ngrx/store';

import { Customer } from '@models';

// Fetch Customers:
export const fetchCustomers = createAction('[Customer] Fetch Initiated');
export const fetchCustomersSuccess = createAction(
  '[Customer] Fetch Success',
  props<{ customers: Customer[] }>()
);
export const fetchCustomersFailed = createAction(
  '[Customer] Fetch Failed',
  props<{ error: Error }>()
);

// Fetch Customer By Id:
export const fetchCustomerById = createAction(
  '[Customer] Fetch By Id Initiated',
  props<{ id: string }>()
);
export const fetchCurrentCustomer = createAction(
  '[Customer] Fetch Current Customer Initiated'
);
export const fetchCustomerByIdSuccess = createAction(
  '[Customer] Fetch By Id  Success',
  props<{ customer: Customer | null }>()
);
export const fetchCustomerByIdFailed = createAction(
  '[Customer] Fetch By Id  Failed',
  props<{ error: Error }>()
);

// Update Customer:
export const updateCustomer = createAction(
  '[Customer] Update Initiated',
  props<{ customer: Customer }>()
);
export const updateCustomerSuccess = createAction(
  '[Customer] Update Success',
  props<{ customer: Customer }>()
);
export const updateCustomerFailed = createAction(
  '[Customer] Update Failed',
  props<{ error: Error }>()
);

// Update Customer Image:
export const updateCustomerImage = createAction(
  '[Customer] Update Customer Image Initiated',
  props<{ file: File; customer: Customer }>()
);
export const updateCustomerImageSuccess = createAction(
  '[Customer] Update Customer Image Success',
  props<{ customer: Customer }>()
);
export const updateCustomerImageFailed = createAction(
  '[Customer] Update Customer Image Failed',
  props<{ error: Error }>()
);
